import { useState, useEffect } from "react";
import { getUser } from "../services/session";
import { useUsers } from "./useAPI";

const useMyEmployees = () => {
  const [myEmployees, setMyEmployees] = useState();
  const user = getUser();
  const [, fetchEmployees] = useUsers(
    {
      url: "managedBy",
      method: "POST",
    },
    { manual: true }
  );

  const getMyEmployees = async () => {
    try {
      const employeesList = await fetchEmployees({ data: { email: user.email } });
      setMyEmployees(employeesList.data.results);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getMyEmployees();
  }, []);

  return myEmployees;
};

export default useMyEmployees;
